import { OccConfig } from '@spartacus/core';

export const defaultOccContentConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        contentSearch: 'contents/search?fields=contents(DEFAULT),pagination(DEFAULT)',
      },
    } as any,
  },
};
